import AxiosGlobalInstance, {
  AxiosPromise,
  IConsorcieiResponse,
} from "@/services/index";
import { IDataForm } from "../../context/FormDataContext";
import { sanitizeLeadPayload } from "@/libs/utils";

export interface IValidate {
  admId: string;
  group: string;
  share: string;
  documentNumber: string;
  registrationId: string;
}

/**
 * Register the lead each step of the form
 * @param formData
 * @return {AxiosPromise<IConsorcieiResponse<Record<string, unknown>>>} Return promise with axios response
 */
export function register(
  formData: IDataForm
): AxiosPromise<IConsorcieiResponse<Record<string, unknown>>> {
  return AxiosGlobalInstance.post(
    `/lead/register`,
    sanitizeLeadPayload(formData)
  );
}

/**
 * Validate lead in external partner API
 * @param {IValidate} data admId, group, share, documentNumber
 * @returns {AxiosPromise<IConsorcieiResponse<Record<string, unknown>>>}
 */
export const validate = (
  data: IValidate
): AxiosPromise<IConsorcieiResponse<Record<string, unknown>>> => {
  return AxiosGlobalInstance.post(`/lead/validate`, {
    admId: data.admId,
    group: data.group,
    share: data.share,
    documentNumber: data.documentNumber,
    offerId: data.registrationId,
  });
};
